// extracted by mini-css-extract-plugin
module.exports = {"conjugationTable":"ConjugationTable_conjugationTable__3gP5N"};